import * as angular from 'angular';

export type USER_ROLES = {
    SHIPPER_USER: 'SHIPPER_USER';
    TSO_USER: 'TSO_USER';
    // TSO_ADMIN: 'TSO_ADMIN', // not exposed in the frontend
    ADMIN: 'ADMIN';
    SUPPORT_ADMIN: 'SUPPORT_ADMIN';
    PRISMA_EDITOR: 'PRISMA_EDITOR';
    SSO_ADMIN: 'SSO_ADMIN';
    SHIPPER_ADMIN: 'SHIPPER_ADMIN';
};

(function () {
    'use strict';

    angular.module('app').constant('USER_ROLES', {
        SHIPPER_USER: 'SHIPPER_USER',
        TSO_USER: 'TSO_USER',
        // TSO_ADMIN: 'TSO_ADMIN', // not exposed in the frontend
        ADMIN: 'ADMIN',
        SUPPORT_ADMIN: 'SUPPORT_ADMIN',
        PRISMA_EDITOR: 'PRISMA_EDITOR',
        SSO_ADMIN: 'SSO_ADMIN',
        SHIPPER_ADMIN: 'SHIPPER_ADMIN'
    });
})();
